import axios from 'axios';
import FilterConditionData = App.Sms.Data.AutomatedCampaigns.FilterConditionData;

export async function index(): Promise<{ filters: FilterConditionData[] }> {
  return axios.get(route('api.sms.filter-types.index')).then((res) => res.data);
}
